import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Button from "@mui/material/Button";
import * as React from "react";
import { useSelector } from "react-redux";
import { ActionModal, ModalContain } from "../../style/utils/Confirmation";
export default function ConfirmationModal({ open = false, handleCancel, handleConfirm }) {
  const Drawer = useSelector((state) => state.drawer);

  return (
    <>
      {open && (
        <ModalContain className={Drawer ? " " : "DrawerOpen"}>
          <ActionModal>
            <div className="IconContain">
              <TaskAltIcon />
            </div>
            <h4 className="Title">Are you sure you want to final save this!</h4>
            <p>This action can't be undone!</p>
            <div className="ButtonContain">
              <Button variant="contained" className="Delete" onClick={handleConfirm}>
               Save
              </Button>
              <Button variant="contained" className="Cancel" onClick={handleCancel}>
                Cancel
              </Button>
            </div>
          </ActionModal>
        </ModalContain>
      )}
    </>
  );
}
